import { translate } from "../translations";

// Sunucudan gelen mesajların çoğu zaten Türkçe ve kullanıcıya gösterilebilir
// durumda. Bu modül yalnızca gösterilemeyecek olanları ayıklayıp yerine anlaşılır
// bir Türkçe karşılık koyuyor; hiçbir yerde ham axios/HTTP metni kullanıcıya
// ulaşmıyor.

// İç detay sızdıran mesajlar — bunları asla göstermiyoruz.
const TECHNICAL_MARKERS =
  /(cast to |objectid|e11000|validationerror|mongo|\bat \/|\bnull\b|\bundefined\b|<html|<!doctype)/i;

// Axios'un / proxy'nin ürettiği İngilizce mesajlar.
const FOREIGN_MARKERS =
  /^(network error|request failed|timeout of|socket hang up|connect e|read econnreset|internal server|bad gateway|service unavailable|not found|forbidden|unauthorized)/i;

// Türkçe ama kullanıcı için anlamsız olan sunucu mesajları: alan adı sızdıranlar,
// yarı İngilizce terimler ve iç doğrulama metinleri.
const REWRITES = [
  [/^geçersiz format/i, "error_invalid_form"],
  [/repeatduration/i, "error_invalid_form"],
  [/hatim instance/i, "error_hatim_not_found"],
  [/qr template/i, "error_qr_template_not_found"],
];

// "Yanlış email veya şifre !" gibi boşluklu ünlemleri düzeltip cümleyi toparlıyoruz.
function polish(message) {
  return String(message)
    .replace(/\s+/g, " ")
    .replace(/\s+([.!?])/g, "$1")
    .replace(/!+$/, ".")
    .trim();
}

export function displayableServerMessage(raw) {
  if (typeof raw !== "string") return null;
  const message = polish(raw);
  if (!message || message.length > 160) return null;
  if (TECHNICAL_MARKERS.test(message)) return null;
  if (FOREIGN_MARKERS.test(message)) return null;

  const rewrite = REWRITES.find(([pattern]) => pattern.test(message));
  if (rewrite) return translate(rewrite[1]);

  return message;
}

// Duruma göre kullanıcıya gösterilecek nihai Türkçe mesaj.
export function apiErrorMessage({ status, serverMessage, errorType, code }) {
  // Bakım mesajını sunucu zaten kullanıcı diliyle yazıyor; okunabilirse onu
  // koruyup yalnızca boş/teknik geldiğinde kendi metnimize düşüyoruz.
  if (errorType === "MAINTENANCE") {
    return displayableServerMessage(serverMessage) || translate("maintenance_message");
  }

  if (!status) {
    return translate(code === "ECONNABORTED" ? "error_timeout" : "error_network");
  }

  if (status >= 500) return translate("error_server");

  const safe = displayableServerMessage(serverMessage);

  switch (status) {
    case 401:
      return safe || translate("error_session_expired");
    case 403:
      return safe || translate("error_forbidden");
    case 404:
      return safe || translate("error_not_found");
    case 429:
      return safe || translate("error_rate_limited");
    default:
      return safe || translate("error_generic");
  }
}
